import { getInvoicePermissionServer } from '@/api/electronicInvoice'
import { ORIGINAL_INVOICE_PERMISSION_ENUM } from '@/views/electronicInvoice/constant'

/**
 * 进入电子发票页前校验原开票权限。
 * @param {Object} to 目标路由
 * @param {Object} from 来源路由
 * @param {Function} next 路由放行方法
 */
function checkInvoicePermission (to, from, next) {
  getInvoicePermissionServer().then(res => {
    const originalInvoicePermission = res && res.data
      ? Number(res.data.originalInvoicePermission)
      : null
    if (res && res.success && originalInvoicePermission === ORIGINAL_INVOICE_PERMISSION_ENUM.unopened) {
      next({ name: 'instantInvoicing', replace: true })
      return
    }
    next()
  }).catch(() => {
    next()
  })
}

export const electronicInvoice = [
  {
    path: '/electronicInvoice',
    name: 'electronicInvoice',
    component: () => import('@/views/electronicInvoice'),
    beforeEnter: checkInvoicePermission,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/electronicInvoice/openInvoice',
    name: 'openInvoice',
    component: () => import('@/views/electronicInvoice/open'),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/electronicInvoice/afterOpenInvoice',
    name: 'afterOpenInvoice',
    component: () => import('@/views/electronicInvoice/afterOpen'),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/electronicInvoice/selectStore',
    name: 'invoiceSelectStore',
    component: () => import('@/views/electronicInvoice/selectStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/electronicInvoice/invoiceSelectSingleStore',
    name: 'invoiceSelectSingleStore',
    component: () => import('@/views/electronicInvoice/selectSingleStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/electronicInvoice/detail',
    name: 'invoiceDetail',
    component: () => import('@/views/electronicInvoice/detail'),
    meta: {
      title: '开票详情'
    }
  },
  {
    path: '/electronicInvoice/search',
    name: 'invoiceSearch',
    component: () => import ('@/views/electronicInvoice/search'),
    meta: {
      title: '搜索'
    }
  }
]
